import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import iView from 'iview'

Vue.use(Router)
const router = new Router({
  routes,
  // mode: 'history'
})

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  if (to.path != '/login') {
    let userToken = sessionStorage.getItem("token");
    if (!userToken) {
      next({ name: 'login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach(to => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
